var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      {
        attrs: {
          hidden: "",
        },
      },
      [
        _vm.required && _vm.sortedItems.length === 0
          ? _c(
              "label",
              {
                staticClass: "hiddeninput",
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "textlabel",
                  },
                  [_vm._v(_vm._s(_vm.label))]
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    required: "",
                    value: "",
                  },
                }),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "formpart",
      },
      [
        _c(
          "ul",
          {
            staticClass: "clean editablelist",
          },
          _vm._l(_vm.sortedItems, function (item) {
            return _c(
              "li",
              {
                key: item.id,
                attrs: {
                  "data-type": item.type,
                },
              },
              [
                item.icon
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: item.icon,
                        role: "info",
                        size: 20,
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.name
                  ? _c("input", {
                      attrs: {
                        type: "hidden",
                        name: _vm.name + "[]",
                      },
                      domProps: {
                        value: item.value,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                item.deletable
                  ? _c(
                      "button",
                      {
                        staticClass: "undecorated",
                        attrs: {
                          title: _vm.$gettextInterpolate(
                            _vm.$gettext("%{ name } löschen"),
                            {
                              name: item.name,
                            }
                          ),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.deleteItem(item)
                          },
                        },
                      },
                      [
                        _c("studip-icon", {
                          staticClass: "text-bottom",
                          attrs: {
                            shape: "trash",
                            role: "clickable",
                            size: 20,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.quicksearch
          ? _c("quicksearch", {
              attrs: {
                searchtype: _vm.quicksearch,
                name: "qs",
                placeholder: _vm.$gettext("Suchen"),
              },
              on: {
                input: _vm.addRange,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectable
      ? _c(
          "label",
          [
            _c("translate", [_vm._v("Oder aus Liste auswählen:")]),
            _vm._v(" "),
            _c(
              "select",
              {
                on: {
                  change: _vm.quickselect,
                  keydown: _vm.navigate_or_select,
                },
              },
              [
                _c(
                  "option",
                  {
                    attrs: {
                      value: "",
                    },
                  },
                  [_c("translate", [_vm._v("Direkt auswählen ...")])],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.selectable, function (opt, idx) {
                  return [
                    opt.label && opt.options
                      ? _c(
                          "optgroup",
                          {
                            key: idx,
                            attrs: {
                              label: opt.label,
                            },
                          },
                          _vm._l(opt.options, function (option, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                attrs: {
                                  disabled: _vm.isSelected(option.value),
                                },
                                domProps: {
                                  value: JSON.stringify({
                                    value: option.value,
                                    name: option.name,
                                  }),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      option.name +
                                        (_vm.isSelected(option.value)
                                          ? " ✓"
                                          : "")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c(
                          "option",
                          {
                            key: idx,
                            attrs: {
                              disabled: _vm.isSelected(opt.value),
                            },
                            domProps: {
                              value: JSON.stringify({
                                value: opt.value,
                                name: opt.name,
                              }),
                            },
                            on: {
                              click: _vm.quicksearch,
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  opt.name +
                                    (_vm.isSelected(_vm.option.value)
                                      ? " ✓"
                                      : "")
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }